export default "__VITE_ASSET__CFzNkfnS__"